<template>
  <div class="appointmentBox">
    <BackBanner
      class="backBanner"
      @goBack="goBack"
      :defaultGoBack="true"
      :isFixed="false"
      title="预约成功"
    />
    <div class="appointmentCon">
      <div class="typeTop">
        <img :src="iconType" />
        <p>恭喜您，预约成功！</p>
      </div>
      <div class="msg">
        <img :src="qrcodeImg" />
        <p>
          专属学习规划老师会再<span>1个工作日</span>内联系您,确认您的诊断时间与诊断老师
        </p>
      </div>
      <!-- <div class="info">
        <div class="title">预约课程信息</div>
        <div class="infoItem">
          <div class="label">课程名称</div>
          <div class="value">{{ detail.subject_name }}·{{ detail.title }}</div>
        </div>
        <div class="infoItem">
          <div class="label">课程类型</div>
          <div class="value">{{ detail.course_type_text }}</div>
        </div>
        <div class="infoItem" v-if="detail.school_address">
          <div class="label">上课地址</div>
          <div class="value">
            {{ detail.school_name }}
            <p>{{ detail.school_address }}</p>
          </div>
        </div>
      </div> -->
      <a href="tel:400-012-1121" class="btnTel">
        <i></i>
        <span>联系学习规划老师</span>
      </a>
    </div>
  </div>
</template>
<script>
import BackBanner from "@/components/backBanner";
export default {
  data() {
    return {
      qrcodeImg: require("../../assets/img/class/iconTeacher.png"),
      iconType: require("../../assets/img/class/iconSuccess.png"),
      detail: "",
    };
  },
  components: { BackBanner },
  mounted() {
    this.getDetail();
  },
  methods: {
    goBack() {
      history.go(-1);
    },
    getDetail() {
      // 获取页面详情内容
      const { id, school_id } = this.$route.query;
      this.$api.classes.getCourseDetail({ id, school_id }).then((res) => {
        if (res.error_code === 0) {
          this.detail = res.result.data;
        } else {
          this.$toast(res.message);
        }
      });
    },
    openQrcode() {
      this.showQrcode = true;
    },
  },
};
</script>
<style scoped lang="scss">
.appointmentBox {
  width: 100%;
  height: 100vh;
  background-color: #f7f8fa;
  display: flex;
  flex-direction: column;
  .backBanner {
    flex: none;
  }
  .appointmentCon {
    background: url("../../assets/img/class/bgYuyue.png") no-repeat top center;
    background-size: 100% auto;
    overflow: auto;
    .typeTop {
      height: 156px;
      text-align: center;
      overflow: hidden;
      img {
        display: block;
        margin: 32px auto 12px auto;
        width: 46px;
        height: 46px;
      }
      p {
        font-size: 24px;
        font-weight: bold;
        color: #8f4d27;
      }
    }
    .msg {
      margin: 0 16px 16px 16px;
      padding: 0 14px 0 16px;
      height: 94px;
      background: #ffffff;
      border-radius: 8px;
      display: flex;
      align-items: center;
      box-shadow: 0px 2px 4px 0px rgba(203, 201, 218, 0.2);
      img {
        display: block;
        width: 40px;
        height: 40px;
        margin-right: 10px;
      }
      p {
        font-size: 14px;
        line-height: 20px;
        color: #212832;
        span {
          color: #e02727;
        }
      }
    }
    .info {
      margin: 0 16px;
      padding: 0 0 24px 16px;
      background: #ffffff;
      border-radius: 8px;
      color: #212832;
      box-shadow: 0px 2px 4px 0px rgba(203, 201, 218, 0.2);
      .title {
        font-size: 16px;
        font-weight: bold;
        line-height: 22px;
        padding: 14px 0 18px 0;
        border-bottom: 1px solid #f5f5f7;
      }
      .infoItem {
        overflow: hidden;
        padding: 16px 16px 0 0;
        font-size: 14px;
        line-height: 20px;
        .label {
          float: left;
          color: #8e959e;
        }
        .value {
          padding-left: 74px;
          p {
            margin-top: 6px;
            font-size: 12px;
            line-height: 18px;
          }
        }
      }
    }
    .btnTel {
      margin: 24px auto;
      width: 170px;
      height: 40px;
      background: #ffffff;
      border-radius: 24px;
      display: flex;
      align-items: center;
      justify-content: center;
      i {
        margin-right: 4px;
        display: block;
        width: 16px;
        height: 16px;
        background: url("../../assets/img/class/iconTel.png") no-repeat;
        background-size: 100% auto;
      }
      span {
        font-weight: 600;
        font-size: 14px;
        color: #212832;
      }
    }
  }
}
</style>
